import { render, staticRenderFns } from "./clue-follow-statistics.vue?vue&type=template&id=94267538"
import script from "./clue-follow-statistics.vue?vue&type=script&lang=js"
export * from "./clue-follow-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports